// ============================================
// App Component
// ============================================

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SWRConfig } from 'swr';
import { AppLayout } from './components/layout/AppLayout';
import Dashboard from './pages/Dashboard';

// Lazy load other pages
import { lazy, Suspense } from 'react';
import { LoadingState } from './components/layout/LoadingState';

const ConstFunnel = lazy(() => import('./pages/ConstFunnel'));
const EcomFunnel = lazy(() => import('./pages/EcomFunnel'));
const EcomMonthlyKPI = lazy(() => import('./pages/EcomMonthlyKPI'));
const MonthlyReport = lazy(() => import('./pages/MonthlyReport'));

function App() {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        dedupingInterval: 60000,
        errorRetryCount: 3,
        onError: (error, key) => {
          console.error(`SWR Error [${key}]:`, error);
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Dashboard />} />
            <Route
              path="const-funnel"
              element={
                <Suspense fallback={<LoadingState />}>
                  <ConstFunnel />
                </Suspense>
              }
            />
            <Route
              path="ecom-funnel"
              element={
                <Suspense fallback={<LoadingState />}>
                  <EcomFunnel />
                </Suspense>
              }
            />
            <Route
              path="ecom-monthly-kpi"
              element={
                <Suspense fallback={<LoadingState />}>
                  <EcomMonthlyKPI />
                </Suspense>
              }
            />
            <Route
              path="monthly-report"
              element={
                <Suspense fallback={<LoadingState />}>
                  <MonthlyReport />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </SWRConfig>
  );
}

export default App;
